<template>
  <v-text-field
    v-model="localValue"
    value="localValue"
    @change="$emit('change', localValue)"
  ></v-text-field>
</template>

<script>
export default {
  name: 'SplitValueAdjuster',
  props: ['mass', 'percentage'],
  data() {
    return {
      localValue: 0,
    };
  },
  methods: {
    getPercentageVal(val, percentage) {
      return (val * (percentage / 100));
    },
    getPercentageValue(val, percentage) {
      return this.getPercentageVal(val, percentage).toFixed(3);
    },
  },
  mounted() {
    const { mass, percentage } = this;
    this.localValue = this.getPercentageValue(mass, percentage);
  },
};
</script>
